import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Google Analytics
const GA_ID = 'G-2DLL1790P2';
const gtagScript = document.createElement('script');
gtagScript.async = true;
gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
document.head.appendChild(gtagScript);
const gtagInline = document.createElement('script');
gtagInline.textContent = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', '${GA_ID}');
`;
document.head.appendChild(gtagInline);
document.title = 'Honduran-American Association';
// Helper to set or create a meta tag
function setMeta(attr: string, attrValue: string, content: string) {
  const selector = `meta[${attr}="${attrValue}"]`;
  // Remove any existing stale tag first
  const existing = document.querySelector(selector);
  if (existing) existing.remove();
  // Create fresh tag with correct content
  const tag = document.createElement('meta');
  tag.setAttribute(attr, attrValue);
  tag.setAttribute('content', content);
  document.head.appendChild(tag);
}
const SITE_TITLE = 'Honduran-American Association';
const SITE_DESC = 'Honduran-American Association: Connect, Empower and Celebrate';
const SITE_IMAGE = 'https://cdn.magicpatterns.com/uploads/b1GB8Z9aEvoE58p9BdX4qx/HonduranAmericanLogoNew.png';
// Favicon
const favicon = document.querySelector("link[rel='icon']") || document.createElement('link');
favicon.setAttribute('rel', 'icon');
favicon.setAttribute('type', 'image/png');
favicon.setAttribute('href', 'https://cdn.magicpatterns.com/uploads/b1GB8Z9aEvoE58p9BdX4qx/HonduranAmericanLogoNew.png');
if (!favicon.parentNode) document.head.appendChild(favicon);
// Standard meta
setMeta('name', 'description', SITE_DESC);
// Open Graph
setMeta('property', 'og:title', SITE_TITLE);
setMeta('property', 'og:description', SITE_DESC);
setMeta('property', 'og:type', 'website');
setMeta('property', 'og:image', SITE_IMAGE);
// Twitter / iMessage card
setMeta('name', 'twitter:card', 'summary_large_image');
setMeta('name', 'twitter:title', SITE_TITLE);
setMeta('name', 'twitter:description', SITE_DESC);
setMeta('name', 'twitter:image', SITE_IMAGE);
render(<App data-id="element-3352" />, document.getElementById('root'));